// src/firebaseConfig.ts
// Firebase init + Firestore handle + the SmartShop API base.
// Red Robin Boutique (GIDO_IE_0015), hosted in dbos-territory-ie (territory-correct).
// apiKey is a public client key (safe to ship, not a secret).
// House rule: short hyphen "-" only.
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyBo5BKRzAsXJ7uNw3e4_5fTaFy1nUwnRr0',
  authDomain: 'dbos-core-stage.firebaseapp.com',
  projectId: 'dbos-core-stage',
  storageBucket: 'dbos-core-stage.firebasestorage.app',
  messagingSenderId: '273538020820',
  appId: '1:273538020820:web:2f5642fdd30b77a1e09241',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// SmartShop cloud functions (central, core-prod). Matches shopConfig.api_base.
export const SMARTSHOP_API = 'https://europe-west1-dbos-core-prod.cloudfunctions.net';
export const CLIENT_ID = 'GIDO_IE_0015';